import Glide from '@glidejs/glide';

/**
 * Glide.js slider handler
 */
function GlideSlider() {

  // Set up properties

  // Create nodelist of all the sliders on the page 
  const sliders = document.querySelectorAll('.glide');
  // slidersCont will be used as a container for sorted sliders
  const slidersCont = {
    home: [],
    product: [],
    bluebox: [],
    cardsSlider: [],
    cardsShips: []
  }
  // glides will be used as a container for instantiated glide objects
  const glides = {
    home: [],
    product: [],
    bluebox: [],
    cardsShips: []
  };
  // glide obj settings
  const glideSetting = {
    common: {
      type: 'carousel',
      startAt: 0,
      perView: 1
    },
    cardsSlider: {
      type: 'carousel',
      startAt: 0,
      perView: 2,
      gap: 30,
      breakpoints: {
        767: {
          perView: 1
        },
        1439: {
          gap: 14
        }
      }
    }
  };
  let counter = 0;
  let glide;
  // state holders
  let glideHomeInstantiated = false;
  let glideHomeDestroyed = false;
  let glideProductInstantiated = false;
  let glideProductDestroyed = false;
  let glideBlueInstantiated = false;
  let glideBlueDestroyed = false;
  let glideCardsSliderInstantiated = false;
  let glideCardsShipsInstantiated = false;
  let glideCardsShipsDestroyed = false;
  
  // sort sliders 
  sliders.forEach(slider => {
    if(slider.classList.contains('home-content__top-stats')) {
      slidersCont.home.push(slider);
    } else if(slider.classList.contains('product-section__bottom-slider')) {
      slidersCont.product.push(slider);
    } else if(slider.classList.contains('bluebox-section__stats')) {
      slidersCont.bluebox.push(slider);
    } else if(slider.classList.contains('cards-section__slider')) {
      slidersCont.cardsSlider.push(slider);
    } else if(slider.classList.contains('cards-section__ships')) {
      slidersCont.cardsShips.push(slider);
    }
  });

 
  /**
   * setUpGlide function
   * 
   * instatiate or destroy glide object
   *
   */
  const setUpGlide = () => {
    
    // check if there are home sliders on the page
    if(slidersCont.home.length > 0) {
      if(window.innerWidth < 1200 && (!glideHomeInstantiated || glideHomeDestroyed)) {
        slidersCont.home.forEach(slider => {
          counter++;
          // add unique class to each slider
          slider.classList.add(`slider-home-${counter}`);
          // instantiate new glide object for each slider
          glide = new Glide(`.slider-home-${counter}`, glideSetting.common).mount();
          // push glide objects to glides.home array
          glides.home.push(glide);
        });
        glideHomeInstantiated = true;
        glideHomeDestroyed = false;
      } else if(window.innerWidth >= 1200 && glideHomeInstantiated) {
        // call destroy() method on every object in glides.home array
        glides.home.forEach(glide => {
          glide.destroy();
        });
        // empty glides.homed array
        glides.home = [];
        glideHomeDestroyed = true;
        glideHomeInstantiated = false;
      }
    }

    // check if there are product sliders on the page
    if(slidersCont.product.length > 0) {
      if(window.innerWidth < 768 && (!glideProductInstantiated || glideProductDestroyed)) {
        slidersCont.product.forEach(slider => {
          counter++;
          // add unique class to each slider
          slider.classList.add(`slider-${counter}`);
          // instantiate new glide object for each slider
          glide = new Glide(`.slider-${counter}`, glideSetting.common).mount();
          // push glide objects to glides.product array
          glides.product.push(glide);
        });
        glideProductInstantiated = true;
        glideProductDestroyed = false;
      } else if(window.innerWidth >= 768 && glideProductInstantiated) {
        // call destroy() method on every object in glides.product array
        glides.product.forEach(glide => {
          glide.destroy();
        });
        // empty glides.product array
        glides.product = [];
        glideProductDestroyed = true;
        glideProductInstantiated = false;
      }
    }

    // check if there are bluebox sliders on the page
    if(slidersCont.bluebox.length > 0) {
      if(window.innerWidth < 768 && (!glideBlueInstantiated || glideBlueDestroyed)) {
        slidersCont.bluebox.forEach(slider => {
          counter++;
          // add unique class to each slider
          slider.classList.add(`slider-${counter}`);
          // instantiate new glide object for each slider
          glide = new Glide(`.slider-${counter}`, glideSetting.common).mount();
          // push glide objects to glides.bluebox array
          glides.bluebox.push(glide);
        });
        glideBlueInstantiated = true;
        glideBlueDestroyed = false;
      } else if(window.innerWidth >= 768 && glideBlueInstantiated) {
        // call destroy() method on every object in glides.bluebox array
        glides.bluebox.forEach(glide => {
          glide.destroy();
        });
        // empty glides.bluebox array
        glides.bluebox = [];
        glideBlueDestroyed = true;
        glideBlueInstantiated = false;
      }
    }

    // check if there are carsSlider sliders on the page
    if(slidersCont.cardsSlider.length > 0 && !glideCardsSliderInstantiated) {
      slidersCont.cardsSlider.forEach(slider => {
        counter++;
        // add unique class to each slider
        slider.classList.add(`slider-${counter}`);
        // instantiate new glide object for each slider
        glide = new Glide(`.slider-${counter}`, glideSetting.cardsSlider).mount();
        glideCardsSliderInstantiated = true;
      });
    }

    // check if there are carsShips sliders on the page
    if(slidersCont.cardsShips.length > 0) {
      if(window.innerWidth < 768 && (!glideCardsShipsInstantiated || glideCardsShipsDestroyed)) {
        slidersCont.cardsShips.forEach(slider => {
          counter++;
          // add unique class to each slider
          slider.classList.add(`slider-${counter}`);
          // instantiate new glide object for each slider
          glide = new Glide(`.slider-${counter}`, glideSetting.common).mount();
          // push glide objects to glides.cardsShips array
          glides.cardsShips.push(glide);
        });
        glideCardsShipsInstantiated = true;
        glideCardsShipsDestroyed = false;
      } else if(window.innerWidth >= 768 && glideCardsShipsInstantiated) {
        // call destroy() method on every object in glides.cardsShips array
        glides.cardsShips.forEach(glide => {
          glide.destroy();
        });
        // empty glides.cardsShips array
        glides.cardsShips = [];
        glideCardsShipsDestroyed = true;
        glideCardsShipsInstantiated = false;
      }
    }
    
  }

  return {
    setUpGlide
  }

}

export default GlideSlider;